<input
  [formControl]="customFormControl"
  class="form-control"
  id="{{ id }}"
  type="tel"
  (keyup)="change($event)"
  placeholder="{{ placeholder }}"
  #phone />
